<template>
  <section class="underwriting-refer">
    <div class="table">
      <div class="tr">
        <span>Contract Period</span>
        <span>{{ getAllOptionName24('period', quoteForm.contr_prd) }}</span>
      </div>
      <div class="tr">
        <span>Building Age</span>
        <span>{{ getAllOptionName24('bldg_ages', quoteForm.bldg_age) }}</span>
      </div>
      <div class="tr">
        <span>Total Contract Sum</span>
        <span>{{ quoteForm.tol_contr_sum }}</span>
      </div>
      <div class="tr">
        <span>Material Damage Coverage</span>
        <span>{{ getOptionName('yesNoOptions', quoteForm.mat_dam_cvr_ind) }}</span>
      </div>
      <div class="tr">
        <span>Third Party Liability Coverage</span>
        <span>{{ getOptionName('yesNoOptions', quoteForm.tp_lia_cvr_ind) }}</span>
      </div>
      <div class="tr">
        <span>Third Party Liability Limit</span>
        <span>{{ getAllOptionName24('limit_of_liability', quoteForm.tppd_limit_amt) }}</span>
      </div>
      <div class="tr">
        <span>Outdoor Work or Scaffolding Work</span>
        <span>{{ getOptionName('yesNoOptions', quoteForm.outdoor_wk_ind) }}</span>
      </div>
      <div class="tr">
        <span>Total Contract Value of Outdoor Work and/or Scaffolding Work</span>
        <span>{{ getAllOptionName24('scaffolding_wk', quoteForm.scaffolding_wk) }}</span>
      </div>
      <div class="tr">
        <span>Employee Compensation</span>
        <span>{{ getOptionName('yesNoOptions', quoteForm.employee_ind) }}</span>
      </div>
      <!-- <div class="tr">
        <span>Contract Sum of Out-Door Work</span>
        <span>{{ quoteForm.outdoor_wk_sum }}</span>
      </div> -->
    </div>
    
    <!-- <template v-if="benefitsList && benefitsList.length > 0">
      <h3>More Benefits</h3>
      <div class="benefits-list">
        <span
          v-for="(item, index) in benefitsList"
          :key="index">
          {{ item }}
        </span>
      </div>
    </template> -->
  </section>
</template>
<script>
import { mapState } from 'vuex'
import MixinOptions from '@/mixins/options'
export default {
  name: 'UnderwritingRefer',
  mixins: [MixinOptions],
  computed: {
    ...mapState('quote', ['quoteForm']),
    localAllOptions() {
      return this.allOptions24
    },
    benefitsList() {
      const { benefits = [] } = this.quoteForm
      if(!benefits) {
        return []
      }
      return benefits.reduce((result, item) => {
        result.push(
          this.getAllOptionName24('benefits', item)
        )
        return result
      }, [])
    }
  }
}
</script>